<template>
  <main class="blog">
    <header class="header header-blog">
      <img
        src="../assets/images/banners/blog_mobile.svg"
        alt=""
        class="is-hidden-tablet banner-mobile"
      />
      <div class="header__content-wrap column column-50 column-offset-50">
        <div class="header__content">
          <h2 class="color-primary">
            Blog
          </h2>
          <p>
            Entérate de todo sobre la facturación <br />
            electrónica.
          </p>
          <!-- <div class="header__actions is-hidden-desktop">
            <a
               
              rel="noopenner noreferer"
              class="button is-rounded bg-primary has-text-white"
              >Prueba Gratis</a
            >
            <a
              class="button is-rounded bg-disabled has-text-white"
              @click="$modal.show('video-demo')"
              >Video Demo</a
            >
          </div> -->
        </div>
      </div>
    </header>
    <section class="section section--main-blog">
      <div class="field">
        <p class="control has-icons-right">
          <input
            class="input is-medium is-rounded is-hovered"
            type="text"
            placeholder="Inicia tu búsqueda aquí..."
          />
          <span class="icon is-medium is-right">
            <i class="fas fa-search"></i>
          </span>
        </p>
      </div>
      <h2>PUBLICACIONES RECIENTES</h2>
      <blog-carrousel idSlider="prim" />
    </section>
  </main>
</template>

<script>
// @ is an alias to /src
import BlogCarrousel from "../components/BlogCarrousel";
export default {
  name: "Blog",
  components: {
    BlogCarrousel
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // background-image: url("../assets/images/banners/blog_mobile.svg");
  // background-repeat: no-repeat;
  // background-size: 100% auto;
  // background-attachment: local;
  // background-origin: border-box;
  // height: 80vh;
  &__content {
    background-color: transparent;
    // height: 60%;
    margin-top: auto;
    width: 100%;
    // padding: 3rem 0;
    p {
      width: 100%;
      margin: 2em 0;
    }
  }
  // @include tablet() {
  //   // height: 70vh;
  // }
  @include tablet() {
    background-image: url("../assets/images/banners/blog.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    max-height: 450px;
    // height: calc(80vh - 120px);
    &__content-wrap {
      padding-top: 20rem;
    }
    &__content {
      background-color: transparent;
      height: 55%;
      margin-top: auto;
      width: 100%;
      // padding: 3rem 0;
      p {
        width: 100%;
        margin: 2em 0;
        padding-right: 0em !important;
      }
    }
    // max-height: 500px;
    // height: 400px;
  }
  @media (min-width: 1024px) {
    background-image: url("../assets/images/banners/blog.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    height: calc(80vh - 120px);
    // max-height: none;
    &__content-wrap {
      padding-top: 0rem;
    }
    &__content {
      background-color: transparent;
      height: 55%;
      margin-top: auto;
      width: 100%;
      // padding: 3rem 0;
      p {
        width: 100%;
        margin: 2em 0;
        padding-right: 0em !important;
      }
    }
    // max-height: 500px;
    // height: 400px;
  }
  @media (min-width: 1200px) {
    background-image: url("../assets/images/banners/blog.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // height: calc(100vh -100px);
    max-height: 650px;
    // height: 400px;
  }
  @media (min-width: 1400px) {
    background-image: url("../assets/images/banners/blog.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    height: calc(90vh - 120px);
    // height: calc(100vh -100px);
    max-height: 1000px;
    // height: 400px;
  }
}
.section {
  padding: 3rem;
  padding-top: 0px;
  @media (max-width: 650px) {
    padding: 0px !important;
  }
  .field {
    max-width: 400px;
    margin: 2rem auto;
    @include laptop() {
      max-width: 600px;
      margin: 2rem auto 8rem;
    }
  }
  .button {
    font-size: 16px;
    font-weight: 500;
  }
  h2 {
    font-weight: normal;
    font-size: 1.2rem;
    text-align: center;
    margin: 4em auto 0;
    font-family: "Geometos", sans-serif;
    @include laptop() {
      text-align: start;
      font-size: 2.2rem;
      width: 80%;
      max-width: 1410px;
      margin: 3em auto;
      // padding-left: 52px;
      box-sizing: border-box;
    }
  }
  &__video {
    width: 100%;
    min-height: 450px;
    padding: 2rem;
    .video__text {
      text-align: left;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      &--right {
        text-align: right;
        align-items: flex-end;
      }
      h3 {
        letter-spacing: 0.018em;
        font-size: 1.8rem;
        width: 85%;
        font-weight: bold;
      }
      p {
        width: 85%;
        font-size: 1.8rem;
      }
    }
    .video__player,
    .video-mini__player {
      background-image: url("../assets/images/video-placeholder.png");
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }
    .video-mini__player {
      height: 300px;
    }
    .video-mini__text {
      margin: 0 auto;
      margin-top: 3rem;
      width: 75%;
      h3 {
        letter-spacing: 0.018em;
        font-size: 2.2rem;
        font-weight: bold;
      }
      p {
        font-size: 1.8rem;
      }
    }
    &:first-child {
      padding-top: 0px;
    }
  }
}
.factura-img {
  display: block;
  width: 500px;
  margin: 4rem auto;
}
.banner-mobile {
  width: 100%;
  @include tablet() {
    display: none;
  }
}
.section--main-blog {
  margin-top: 0rem;
  @include tablet() {
    margin-top: 8rem;
  }
}
</style>
